/* eslint-disable react/jsx-key */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Accordion from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Minus from "@insite/mobius/Icons/Minus";
import { DataTableHead, DataTableHeader } from "@insite/mobius/index";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Tab from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Plus from "@tIntermatic/Icons/Plus";
import CustomApplicationState from "@tIntermatic/Store/CustomApplicationState";
import parse from "html-react-parser";
import chunk from "lodash/chunk";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    applications = "applications",
    features = "features",
    specifications = "specifications",
    model = "model",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.applications]: string;
        [fields.features]: string;
        [fields.specifications]: string;
        [fields.model]: string;
    };
}

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    return {
        page: getCurrentPage(state),
        isProductDataLoading: state.data.products.isLoading,
        state,
    };
};

type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps>;

export interface INTProductDetailsInformationStyles {
    documentGridItem?: GridItemProps;
    attributeTypeWrapper?: InjectableCss;
    attributeTypeLabelText?: TypographyPresentationProps;
    attributeTypeValuesText?: TypographyPresentationProps;
    tabGroup?: TabGroupPresentationProps;
    tabCss?: InjectableCss;
    selectedTabCss?: InjectableCss;
    dataTableCellCss?: InjectableCss;
    attrdataTableCellCss?: InjectableCss;
    dataRowCss?: InjectableCss;
    accordionSection?: AccordionSectionPresentationProps;
    wrapper?: InjectableCss;
    application?: InjectableCss;
    applicationWrapper?: InjectableCss;
    applicationLi?: InjectableCss;
    featureLi?: InjectableCss;
    specAttrdataTableCellCss?: InjectableCss;
    specDataTableCellCss?: InjectableCss;
    container?: InjectableCss;
    columnCells?: InjectableCss;
    rowCells?: InjectableCss;
    modelLinks?: InjectableCss;
}

export const specificationsStyles: INTProductDetailsInformationStyles = {
    documentGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    attributeTypeLabelText: {
        css: css`
            font-weight: 600;
            letter-spacing: 0;
            text-align: justify;
            color: #33333a;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                        font-size: 14px;
                        line-height: 17px;
                    `,
                    css`
                        padding: 0;
                        font-size: 14px;
                        line-height: 17px;
                    `,
                    css`
                        font-size: 14px;
                        line-height: 24px;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 24px;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 24px;
                    `,
                ])}
        `,
    },
    attributeTypeValuesText: {
        css: css`
            color: #33333a;
            font-weight: 300;
            letter-spacing: 0;
            text-align: justify;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 14px;
                        line-height: 17px;
                    `,
                    css`
                        font-size: 14px;
                        line-height: 17px;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 24px;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 24px;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 24px;
                    `,
                ])}
        `,
    },
    tabGroup: {
        cssOverrides: {
            tabContent: css`
                border-top: 1px solid #e5e5e5;
                border-bottom: none;
                padding: 32px 0 32px 0;
                > ul {
                    margin-top: 0;
                }
                > p[class^="TypographyStyle"] {
                    > html {
                        > body {
                            ul {
                                margin-top: 0;
                                li:first-child {
                                    margin-top: 0;
                                }
                            }
                        }
                    }
                }
            `,
        },
    },

    tabCss: {
        css: css`
            border: 1px solid #e5e5e5 !important;
            background-color: #91adce;
            padding: 16px 42.5px;
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-right: 5px;
            > span {
                font-size: 13px;
                font-weight: 600;
                letter-spacing: 0.78px;
                line-height: 16px;
                text-align: center;
                color: #ffffff;
                text-transform: uppercase;
            }
            &:hover {
                background-color: #688eb9;
            }
        `,
    },

    selectedTabCss: {
        css: css`
            border: 1px solid #e5e5e5 !important;
            border-bottom: 0px !important;
            background-color: #ffffff;
            padding: 16px 42.5px;
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-right: 5px;
            > span {
                font-size: 13px;
                font-weight: 600;
                letter-spacing: 0.78px;
                line-height: 16px;
                text-align: center;
                color: #33333a;
                text-transform: uppercase;
            }
            &:hover {
                border-bottom: 0px !important;
                background-color: #ffffff;
            }
        `,
    },

    dataTableCellCss: {
        css: css`
            border: none;
            white-space: normal;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                    `,
                    css`
                        padding: 0;
                    `,
                    css`
                        height: 0;
                    `,
                    css`
                        height: 0;
                    `,
                    null,
                ])}
        `,
    },

    attrdataTableCellCss: {
        css: css`
            padding: 0 20px;
            white-space: normal;
            box-sizing: content-box;
            width: 30%;
            border: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 40%;
                    `,
                    null,
                    null,
                ])}
        `,
    },

    wrapper: {
        css: css`
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        `,
    },

    accordionSection: {
        toggleIconProps: {
            src: Minus,
            size: 15,
        },

        expandIconProps: {
            src: Plus,
            size: 15,
        },

        headerProps: {
            css: css`
                > button {
                    background: #fff;
                    border: none;
                    padding: 13px 9px 13px 15px !important;
                    > span {
                        font-size: 18px;
                        font-weight: 600;
                        letter-spacing: 0;
                        line-height: 22px;
                        color: #333333;
                    }
                }
            `,
        },

        panelProps: {
            css: css`
                border: none;
                padding: 0 15px 15px 0;
                font-size: 16px;
                font-weight: 300;
                letter-spacing: 0;
                line-height: 24px;
                color: #33333a;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            padding-bottom: 7px;
                        `,
                        css`
                            padding-bottom: 7px;
                        `,
                    ])}
            `,
        },
    },

    dataRowCss: {
        css: css`
            :nth-child(even) {
                background-color: #f4f6fa !important;
            }
        `,
    },
    application: {
        css: css`
            color: #33333a !important;
            font-size: 16px !important;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 20px;
            padding-left: 10px;
        `,
    },
    applicationWrapper: {
        css: css`
            list-style: disc;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 0 0 0 11px;
                    `,
                    css`
                        margin: 0 0 0 11px;
                    `,
                    css`
                        margin: 30px 0 0 40px;
                    `,
                    css`
                        margin: 30px 0 0 40px;
                    `,
                    css`
                        margin: 30px 0 0 40px;
                    `,
                ])}
        `,
    },
    applicationLi: {
        css: css`
            font-size: 12px;
            margin: 0px 0px 10px 20px;
        `,
    },
    featureLi: {
        css: css`
            font-size: 12px;
            margin: 0px 0px 10px 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0;
                        `,
                        css`
                            margin: 0;
                        `,
                        null,
                        null,
                    ],
                    "minMax",
                )}
            > html {
                > body {
                    > ul {
                        margin-top: 0px;
                        padding: 0px 0px 0px 20px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        padding: 0px 0px 0px 10px;
                                    `,
                                    css`
                                        padding: 0px 0px 0px 10px;
                                    `,
                                    null,
                                    null,
                                ],
                                "minMax",
                            )}
                        > li {
                            color: #33333a !important;
                            font-size: 16px !important;
                            font-weight: 300;
                            letter-spacing: 0;
                            line-height: 20px;
                            padding-left: 10px;
                            margin: 0px 0px 13px 20px;
                            ::marker {
                                font-size: 12px;
                            }
                            a[class^="StyledButton"] {
                                > span {
                                    font-size: 16px;
                                    font-weight: 600;
                                    letter-spacing: 0;
                                    line-height: 20px;
                                    color: #006bc0;
                                    &:hover {
                                        color: #006bc0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    specDataTableCellCss: {
        css: css`
            border: none;
            white-space: normal;
            width: 30%;
        `,
    },
    specAttrdataTableCellCss: {
        css: css`
            padding: 0 16px;
            white-space: normal;
            box-sizing: content-box;
            width: 15%;
            border: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0px 12px;
                        `,
                        null,
                    ],
                    "minMax",
                )}
        `,
    },
    container: {
        css: css`
            overflow: auto;
            width: 100%;
        `,
    },
    columnCells: {
        css: css`
            th {
                width: 25%;
                background: #f4f6fa;
                span {
                    width: 126px;
                    white-space: pre-wrap;
                    display: block;
                    font-size: 15px;
                    line-height: 22px;
                    font-weight: 600;
                    // text-align: justify;
                    text-transform: uppercase;
                }
            }
        `,
    },
    rowCells: {
        css: css`
            &:nth-child(even) {
                background: #f4f6fa;
            }
            td {
                width: 25%;
                span {
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: 400;
                    text-align: justify;
                    text-transform: capitalize;
                }
            }
        `,
    },
    modelLinks: {
        css: css`
            > span {
                color: #006bc0 !important;
            }
        `,
    },
};

const StyledUl = getStyledWrapper("ul");
const StyledLi = getStyledWrapper("li");

const styles = specificationsStyles;

const INTProductDetailsInformation: React.FC<Props> = ({
    product: { attributeTypes, specifications, properties },
    fields,
    page,
    isProductDataLoading,
    product,
    state,
}) => {
    const crossSellsId = state.t_components.relatedProductFilter.relatedProductsCarouselIdMapping[product.id];
    const relatedProducts = crossSellsId ? getProductsForProductInfoList(state, crossSellsId) : undefined;
    const [currentTab, setCurrentTab] = useState("");

    const features = (specifications ?? []).filter(specification => {
        return specification.name === "Features";
    });
    const applications = (attributeTypes ?? []).filter(attributeType => {
        return attributeType.name === "Applications";
    });
    const certificationTypes = ["EpiCertifications"];

    const specificationsList = (attributeTypes ?? []).filter(attributeType => {
        return certificationTypes.indexOf(attributeType.name) === -1 && attributeType.name !== "Applications";
    });
    const newSpecificationList: any[] = [...specificationsList];

    const relatedProductData: any[] = [];
    relatedProducts?.map(data => {
        const rows: any[] = [];
        data?.attributeTypes?.map(attributeType => {
            if (!attributeType.attributeValues) {
                return null;
            }
            const obj = {
                [attributeType.name]: attributeType?.attributeValues[0].valueDisplay,
            };
            obj.productNumber = data.productNumber;
            obj.unitsPerPallet = data.properties.unitsPerPallet;
            obj.canonicalUrl = data.canonicalUrl;
            rows.push(obj);
        });
        relatedProductData.push(rows.reduce((r, c) => Object.assign(r, c), {}));
    });

    const AttributeArr: string[] =
        product && product?.properties && product.properties?.attributeTypeDisplayed
            ? product?.properties?.attributeTypeDisplayed.split(",").map(value => {
                  return value.trim().toLowerCase();
              })
            : [];

    const relatedProductTable = relatedProducts?.map(data =>
        data.attributeTypes?.filter(attr => AttributeArr.some(attrName => attrName === attr.name.trim().toLowerCase())),
    );

    const properties1 = relatedProducts?.map(data => data.properties);

    const excludedProperties = new Set();
    properties1 &&
        properties1?.forEach(obj => {
            Object.keys(obj).forEach(key => {
                excludedProperties.add(key.trim().toLowerCase());
            });
        });

    const filteredAttributes = AttributeArr?.filter(attribute => !excludedProperties.has(attribute));

    const filteredProperties: Record<string, string> = {};

    properties1?.forEach((properties: Record<string, string>) => {
        Object.keys(properties).forEach(propertyKey => {
            const lowercasePropertyKey = propertyKey.trim().toLowerCase();
            if (AttributeArr.includes(lowercasePropertyKey)) {
                filteredProperties[lowercasePropertyKey] = properties[propertyKey];
            }
        });
    });

    const filteredPropertyKeys = Object.keys(filteredProperties);
    const includedSelfPrimingProperty = product?.properties?.includeSelfPriming
        ?.split(",")
        ?.map(product => product.trim());
    const includedLeafScreenProperty = product?.properties?.includeLeafScreen
        ?.split(",")
        ?.map(product => product.trim());

    // eslint-disable-next-line array-callback-return
    for (const [key, value] of Object.entries(properties)) {
        if (
            key !== "competitorProduct" &&
            key !== "isObsolete" &&
            key !== "promoColor" &&
            key !== "promoMessageEN" &&
            key !== "promoMessageES" &&
            key !== "promoMessageFR" &&
            key !== "promoMessageNewtab" &&
            key !== "promoPageLinkEN" &&
            key !== "promoPageLinkES" &&
            key !== "promoPageLinkFR" &&
            key !== "programmingGuideURL" &&
            key !== "firmwareDownloadURL" &&
            key !== "cfm" &&
            key !== "hp" &&
            key !== "voltagesSinglePhase" &&
            key !== "onOffSwitchOption" &&
            key !== "includeLeafScreen" &&
            key !== "includeSelfPriming" &&
            !(key === "selfPriming" && !includedSelfPrimingProperty?.includes(product?.productNumber)) &&
            !(key === "leafScreen" && !includedLeafScreenProperty?.includes(product?.productNumber)) &&
            value
        ) {
            const elem = {
                attributeValues: [
                    {
                        id: key,
                        value,
                        sortOrder: Math.random(),
                        valueDisplay: value,
                    },
                ],
                id: key,
                includeOnProduct: false,
                isComparable: false,
                isFilter: false,
                isSearchable: false,
                label: key,
                name: key,
                sortOrder: Math.random(),
                isCustom: true,
            };
            newSpecificationList.push(elem);
        }
    }
    const renderingApplications = applications && applications?.length > 0;
    const renderingSpecifications = newSpecificationList && newSpecificationList.length > 0;
    const renderingFeatures =
        features && features?.length > 0 && features?.map(feature => feature.htmlContent).toString().length > 90;

    const featuresTab = (
        <Tab
            headline={fields.features}
            tabKey="Features"
            {...(currentTab === "Features" ? { ...styles.selectedTabCss } : { ...styles.tabCss })}
        >
            {features?.map(feature => (
                <StyledWrapper {...styles.featureLi}>
                    <>{parse(feature.htmlContent, parserOptions)}</>
                </StyledWrapper>
            ))}
        </Tab>
    );
    const applicationsTab = (
        <Tab
            headline={fields.applications}
            tabKey="Applications"
            {...(currentTab === "Applications" ? { ...styles.selectedTabCss } : { ...styles.tabCss })}
        >
            {applications?.map(application => (
                <>
                    <StyledUl {...styles.applicationWrapper}>
                        {application.attributeValues?.map(attr => (
                            <StyledLi {...styles.applicationLi}>
                                <StyledWrapper {...styles.application}>{attr.valueDisplay}</StyledWrapper>
                            </StyledLi>
                        ))}
                    </StyledUl>
                </>
            ))}
        </Tab>
    );
    const specificationsTab = () => {
        const secificationRows = chunk(newSpecificationList, 2);

        return (
            <Tab
                headline={properties?.isFamilySeries === "True" ? fields.model : fields.specifications}
                tabKey="Specifications"
                {...(currentTab === "Specifications" ? { ...styles.selectedTabCss } : { ...styles.tabCss })}
            >
                <GridContainer gap={0}>
                    <GridItem width={[12, 12, 12, 12, 12]}>
                        {properties.isFamilySeries === "True" ? (
                            <>
                                <StyledWrapper {...styles.container}>
                                    <DataTable>
                                        <DataTableHead {...styles.columnCells}>
                                            <DataTableHeader>{translate("Model")}</DataTableHeader>
                                            {filteredAttributes.map(attribute => {
                                                const cell =
                                                    relatedProductTable &&
                                                    relatedProductTable[0]?.find(
                                                        item => item.name?.toLowerCase() === attribute,
                                                    );
                                                if (cell) {
                                                    return (
                                                        <DataTableHeader key={cell.id}>
                                                            {translate(cell.label)}
                                                        </DataTableHeader>
                                                    );
                                                }
                                                return null;
                                            })}
                                            {Object.entries(filteredProperties).map(([attribute]) => (
                                                <DataTableHeader key={attribute}>
                                                    {translate(attribute)}
                                                </DataTableHeader>
                                            ))}
                                        </DataTableHead>
                                        <DataTableBody>
                                            {relatedProducts?.map((product, rowIndex) => {
                                                const rowCells =
                                                    (relatedProductTable && relatedProductTable[rowIndex]) || [];
                                                return (
                                                    <DataTableRow key={product.id} {...styles.rowCells}>
                                                        <DataTableCell>
                                                            <Link {...styles.modelLinks} href={product.canonicalUrl}>
                                                                {product.productNumber}
                                                            </Link>
                                                        </DataTableCell>
                                                        {filteredAttributes.map(attribute => {
                                                            const cell = rowCells.find(
                                                                item => item.name?.toLowerCase() === attribute,
                                                            );
                                                            if (cell) {
                                                                const valueDisplay =
                                                                    cell.attributeValues?.[0]?.valueDisplay || "";
                                                                return (
                                                                    <DataTableCell key={`${product.id}-${cell.id}`}>
                                                                        {valueDisplay}
                                                                    </DataTableCell>
                                                                );
                                                            }

                                                            return (
                                                                <DataTableCell key={`${product.id}-${attribute}`}>
                                                                    {/* Render an empty cell */}
                                                                </DataTableCell>
                                                            );
                                                        })}
                                                        {filteredPropertyKeys.map(filteredPropertyKey => {
                                                            const normalizedPropertyKey =
                                                                filteredPropertyKey?.toLowerCase();

                                                            const lowercaseProperties: Record<string, string> = {};
                                                            for (const key in product?.properties) {
                                                                lowercaseProperties[key.toLowerCase()] =
                                                                    product?.properties[key];
                                                            }

                                                            const propertyValue =
                                                                lowercaseProperties[normalizedPropertyKey] || "";

                                                            return (
                                                                <DataTableCell
                                                                    key={`${product.id}-${filteredPropertyKey}`}
                                                                >
                                                                    {propertyValue}
                                                                </DataTableCell>
                                                            );
                                                        })}
                                                    </DataTableRow>
                                                );
                                            })}
                                        </DataTableBody>
                                    </DataTable>
                                </StyledWrapper>
                            </>
                        ) : (
                            <DataTable>
                                <DataTableBody>
                                    {secificationRows?.map(secificationRow => {
                                        return (
                                            <DataTableRow {...styles.dataRowCss}>
                                                {secificationRow?.map(
                                                    (specification: {
                                                        name: string | number | undefined;
                                                        label: any;
                                                        attributeValues: any;
                                                        isCustom: boolean;
                                                    }) => (
                                                        <>
                                                            <DataTableCell {...styles.specAttrdataTableCellCss}>
                                                                <Typography {...styles.attributeTypeLabelText}>
                                                                    {specification.isCustom
                                                                        ? translate(specification.label)
                                                                        : specification.label}
                                                                </Typography>
                                                            </DataTableCell>
                                                            <DataTableCell {...styles.specDataTableCellCss}>
                                                                <Typography {...styles.attributeTypeValuesText}>
                                                                    {specification
                                                                        .attributeValues!.map(
                                                                            (attributeValue: { valueDisplay: any }) =>
                                                                                attributeValue.valueDisplay,
                                                                        )
                                                                        .join(", ")}
                                                                </Typography>
                                                            </DataTableCell>
                                                        </>
                                                    ),
                                                )}
                                            </DataTableRow>
                                        );
                                    })}
                                </DataTableBody>
                            </DataTable>
                        )}
                    </GridItem>
                </GridContainer>
            </Tab>
        );
    };

    const tabs: JSX.Element[] = [];
    if (renderingFeatures && !Object.values(isProductDataLoading)[0]) {
        tabs.push(featuresTab);
    }
    if (renderingApplications && !Object.values(isProductDataLoading)[0]) {
        tabs.push(applicationsTab);
    }
    if (renderingSpecifications && !Object.values(isProductDataLoading)[0]) {
        tabs.push(specificationsTab());
    }

    const handleTabChange = (event: React.MouseEvent | React.KeyboardEvent) => {
        if (event) {
            setCurrentTab(event.currentTarget.id);
        }
    };

    useEffect(() => {
        if (!Object.values(isProductDataLoading)[0] && !currentTab && tabs.length > 0) {
            setCurrentTab(tabs[0].props.tabKey);
        }
    }, [tabs]);
    return (
        <>
            <Hidden
                below="md"
                css={css`
                    margin-top: 55px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                `}
            >
                {currentTab && tabs.length > 0 && (
                    <TabGroup {...styles.tabGroup} onTabChange={handleTabChange} current={currentTab}>
                        {tabs}
                    </TabGroup>
                )}
            </Hidden>
            <Hidden
                above="md"
                css={css`
                    padding: 0 20px;
                    margin-top: -30px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                        ])}
                `}
            >
                {renderingFeatures && (
                    <Accordion headingLevel={1} {...styles.wrapper}>
                        <ManagedAccordionSection
                            title={fields.features}
                            data-test-selector="productDetails_Features"
                            initialExpanded={false}
                            {...styles.accordionSection}
                        >
                            {features?.map(feature => (
                                <StyledWrapper {...styles.featureLi}>
                                    <>{parse(feature.htmlContent, parserOptions)}</>
                                </StyledWrapper>
                            ))}
                        </ManagedAccordionSection>
                    </Accordion>
                )}
                {renderingApplications && (
                    <Accordion headingLevel={1} {...styles.wrapper}>
                        <ManagedAccordionSection
                            title={fields.applications}
                            data-test-selector="productDetails_Application"
                            initialExpanded={false}
                            {...styles.accordionSection}
                        >
                            {applications?.map(application => (
                                <>
                                    <StyledUl {...styles.applicationWrapper}>
                                        {application.attributeValues?.map(attr => (
                                            <StyledLi {...styles.applicationLi}>
                                                <StyledWrapper {...styles.application}>{attr.value}</StyledWrapper>
                                            </StyledLi>
                                        ))}
                                    </StyledUl>
                                </>
                            ))}
                        </ManagedAccordionSection>
                    </Accordion>
                )}
                {renderingSpecifications && (
                    <Accordion headingLevel={1} {...styles.wrapper}>
                        <ManagedAccordionSection
                            title={properties?.isFamilySeries === "True" ? fields.model : fields.specifications}
                            data-test-selector="productDetails_Specifications"
                            initialExpanded={false}
                            {...styles.accordionSection}
                        >
                            <GridContainer gap={0}>
                                <GridItem width={12}>
                                    {properties.isFamilySeries === "True" ? (
                                        <>
                                            <StyledWrapper {...styles.container}>
                                                <DataTable>
                                                    <DataTableHead {...styles.columnCells}>
                                                        <DataTableHeader>{translate("Model")}</DataTableHeader>
                                                        {filteredAttributes.map(attribute => {
                                                            const cell =
                                                                relatedProductTable &&
                                                                relatedProductTable[0]?.find(
                                                                    item => item.name?.toLowerCase() === attribute,
                                                                );
                                                            if (cell) {
                                                                return (
                                                                    <DataTableHeader key={cell.id}>
                                                                        {translate(cell.label)}
                                                                    </DataTableHeader>
                                                                );
                                                            }
                                                            return null;
                                                        })}
                                                        {Object.entries(filteredProperties).map(([attribute]) => (
                                                            <DataTableHeader key={attribute}>
                                                                {translate(attribute)}
                                                            </DataTableHeader>
                                                        ))}
                                                    </DataTableHead>
                                                    <DataTableBody>
                                                        {relatedProducts?.map((product, rowIndex) => {
                                                            const rowCells =
                                                                (relatedProductTable &&
                                                                    relatedProductTable[rowIndex]) ||
                                                                [];
                                                            return (
                                                                <DataTableRow key={product.id} {...styles.rowCells}>
                                                                    <DataTableCell>
                                                                        <Link
                                                                            {...styles.modelLinks}
                                                                            href={product.canonicalUrl}
                                                                        >
                                                                            {product.productNumber}
                                                                        </Link>
                                                                    </DataTableCell>
                                                                    {filteredAttributes.map(attribute => {
                                                                        const cell = rowCells.find(
                                                                            item =>
                                                                                item.name?.toLowerCase() === attribute,
                                                                        );
                                                                        if (cell) {
                                                                            const valueDisplay =
                                                                                cell.attributeValues?.[0]
                                                                                    ?.valueDisplay || "";
                                                                            return (
                                                                                <DataTableCell
                                                                                    key={`${product.id}-${cell.id}`}
                                                                                >
                                                                                    {valueDisplay}
                                                                                </DataTableCell>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <DataTableCell
                                                                                key={`${product.id}-${attribute}`}
                                                                            >
                                                                                {/* Render an empty cell */}
                                                                            </DataTableCell>
                                                                        );
                                                                    })}
                                                                    {filteredPropertyKeys.map(filteredPropertyKey => {
                                                                        const normalizedPropertyKey =
                                                                            filteredPropertyKey?.toLowerCase();

                                                                        const lowercaseProperties: Record<
                                                                            string,
                                                                            string
                                                                        > = {};
                                                                        for (const key in product?.properties) {
                                                                            lowercaseProperties[key.toLowerCase()] =
                                                                                product?.properties[key];
                                                                        }

                                                                        const propertyValue =
                                                                            lowercaseProperties[
                                                                                normalizedPropertyKey
                                                                            ] || "";

                                                                        return (
                                                                            <DataTableCell
                                                                                key={`${product.id}-${filteredPropertyKey}`}
                                                                            >
                                                                                {propertyValue}
                                                                            </DataTableCell>
                                                                        );
                                                                    })}
                                                                </DataTableRow>
                                                            );
                                                        })}
                                                    </DataTableBody>
                                                </DataTable>
                                            </StyledWrapper>
                                        </>
                                    ) : (
                                        <DataTable>
                                            <DataTableBody>
                                                {newSpecificationList?.map(specification => (
                                                    <DataTableRow key={specification.name} {...styles.dataRowCss}>
                                                        <DataTableCell {...styles.attrdataTableCellCss}>
                                                            <Typography {...styles.attributeTypeLabelText}>
                                                                {specification.isCustom
                                                                    ? translate(specification.label)
                                                                    : specification.label}
                                                            </Typography>
                                                        </DataTableCell>
                                                        <DataTableCell {...styles.dataTableCellCss}>
                                                            <Typography {...styles.attributeTypeValuesText}>
                                                                {specification
                                                                    .attributeValues!.map(
                                                                        (attributeValue: { valueDisplay: any }) =>
                                                                            attributeValue.valueDisplay,
                                                                    )
                                                                    .join(", ")}
                                                            </Typography>
                                                        </DataTableCell>
                                                    </DataTableRow>
                                                ))}
                                            </DataTableBody>
                                        </DataTable>
                                    )}
                                </GridItem>
                            </GridContainer>
                        </ManagedAccordionSection>
                    </Accordion>
                )}
            </Hidden>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(INTProductDetailsInformation)),
    definition: {
        displayName: "Product Details Information",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.applications,
                displayName: "heading For Applications",
                editorTemplate: "TextField",
                defaultValue: "Applications",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.features,
                displayName: "heading For Features",
                editorTemplate: "TextField",
                defaultValue: "Features",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.specifications,
                displayName: "heading For Specifications",
                editorTemplate: "TextField",
                defaultValue: "Specifications",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.model,
                displayName: "heading For Model",
                editorTemplate: "TextField",
                defaultValue: "Models",
                fieldType: "Translatable",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
